// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print{h1,h2,h3{page-break-after:avoid;break-after:avoid}}`, "",{"version":3,"sources":["webpack://./src/components/Page/TextEditor.vue"],"names":[],"mappings":"AACA,aACC,SACC,sBAAA,CACA,iBAAA,CAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
